/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTenantProjectLinkDto } from '../models/work-create-tenant-project-link-dto';
import { WorkProject } from '../models/work-project';
import { WorkTenantProjectLink } from '../models/work-tenant-project-link';
import { WorkUpdateTenantProjectLinkDto } from '../models/work-update-tenant-project-link-dto';

@Injectable({ providedIn: 'root' })
export class WorkTenantsProjectLinksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectLinksV2ControllerCreate()` */
  static readonly ProjectLinksV2ControllerCreatePath = '/v2/tenants/project-links';

  /**
   * Required permissions: tenants:create, projects:read, projects:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectLinksV2ControllerCreate$Response(
    params: {
      body: WorkCreateTenantProjectLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantProjectLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantProjectLink>;
      })
    );
  }

  /**
   * Required permissions: tenants:create, projects:read, projects:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectLinksV2ControllerCreate(
    params: {
      body: WorkCreateTenantProjectLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantProjectLink> {
    return this.projectLinksV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantProjectLink>): WorkTenantProjectLink => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerSearchExternalProjects()` */
  static readonly ProjectLinksV2ControllerSearchExternalProjectsPath = '/v2/tenants/project-links/search/external-projects';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerSearchExternalProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerSearchExternalProjects$Response(
    params: {
      tenantId: number;
      numberQualified: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerSearchExternalProjectsPath, 'get');
    if (params) {
      rb.query('tenantId', params.tenantId, {});
      rb.query('numberQualified', params.numberQualified, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerSearchExternalProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerSearchExternalProjects(
    params: {
      tenantId: number;
      numberQualified: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.projectLinksV2ControllerSearchExternalProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerFindAll()` */
  static readonly ProjectLinksV2ControllerFindAllPath = '/v2/tenants/project-links/byProjectId/{projectId}';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerFindAll$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantProjectLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerFindAllPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantProjectLink>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerFindAll(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantProjectLink>> {
    return this.projectLinksV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantProjectLink>>): Array<WorkTenantProjectLink> => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerFindOne()` */
  static readonly ProjectLinksV2ControllerFindOnePath = '/v2/tenants/project-links/{linkId}';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerFindOne$Response(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantProjectLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('linkId', params.linkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantProjectLink>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerFindOne(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantProjectLink> {
    return this.projectLinksV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantProjectLink>): WorkTenantProjectLink => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerUpdate()` */
  static readonly ProjectLinksV2ControllerUpdatePath = '/v2/tenants/project-links/{linkId}';

  /**
   * Required permissions: tenants:read, projects:read, projects:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectLinksV2ControllerUpdate$Response(
    params: {
      linkId: number;
      body: WorkUpdateTenantProjectLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantProjectLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerUpdatePath, 'put');
    if (params) {
      rb.path('linkId', params.linkId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantProjectLink>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, projects:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectLinksV2ControllerUpdate(
    params: {
      linkId: number;
      body: WorkUpdateTenantProjectLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantProjectLink> {
    return this.projectLinksV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantProjectLink>): WorkTenantProjectLink => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerRemove()` */
  static readonly ProjectLinksV2ControllerRemovePath = '/v2/tenants/project-links/{linkId}';

  /**
   * Required permissions: tenants:delete, projects:read, projects:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerRemove$Response(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('linkId', params.linkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: tenants:delete, projects:read, projects:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerRemove(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectLinksV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerGetExternalProject()` */
  static readonly ProjectLinksV2ControllerGetExternalProjectPath = '/v2/tenants/project-links/{linkId}/external-project';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerGetExternalProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerGetExternalProject$Response(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerGetExternalProjectPath, 'get');
    if (params) {
      rb.path('linkId', params.linkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerGetExternalProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerGetExternalProject(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.projectLinksV2ControllerGetExternalProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `projectLinksV2ControllerGetExternalTasks()` */
  static readonly ProjectLinksV2ControllerGetExternalTasksPath = '/v2/tenants/project-links/{linkId}/external-tasks';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectLinksV2ControllerGetExternalTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerGetExternalTasks$Response(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsProjectLinksV2Service.ProjectLinksV2ControllerGetExternalTasksPath, 'get');
    if (params) {
      rb.path('linkId', params.linkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectLinksV2ControllerGetExternalTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectLinksV2ControllerGetExternalTasks(
    params: {
      linkId: number;
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.projectLinksV2ControllerGetExternalTasks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

}
